import React from "react";
import { SeparatorProps } from "../types";
import { Divider } from "@mui/material";

export function Separator({ className }: SeparatorProps) {
    return (
        <Divider 
            className={className} 
            sx={{ my: 1 }} 
        />
    );
}

export default Separator;
